export const SET_SELECTED_INSIGHT = 'SET_SELECTED_INSIGHT';
export const SET_USER_INSIGHT = 'SET_USER_INSIGHT';